import React, { FC } from 'react';
import cn from 'clsx';
import { css } from 'linaria';

import AutoplayVideo from '../AutoplayVideo';
import SlatButton from '../SlatButton';

const TILE_STYLES = css`
  min-width: 296px;
  box-shadow: 0px 2px 12px 4px rgba(0, 0, 0, 0.1);

  @screen md {
    min-width: auto;
    box-shadow: none;
  }
`;

const VIDEO_STYLES = css`
  position: relative;

  @screen lg {
    &::after {
      background-color: #fffaf2;
      content: '';
      position: absolute;
      height: 33.3%;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -10;
    }
  }
`;

const TILE_TEXT_STYLES = css`
  @screen md {
    background-color: #fffaf2;
  }
`;

const ProductTile: FC<any> = ({ description, features, link, title, video }) => (
  <div className={cn(TILE_STYLES, 'flex flex-col w-3/4 flex-shrink-0 md:w-1/2 md:flex-shrink')}>
    <div className={cn(VIDEO_STYLES)}>
      <AutoplayVideo
        className="w-full px-4 py-6 md:px-2 md:pt-6 md:pb-4 lg:px-4 lg:pb-0 xl:px-12 xl:pt-12"
        videoClassName="pp-drop-shadow w-full"
        {...video}
        loop="false"
      />
    </div>
    <div
      className={cn(
        TILE_TEXT_STYLES,
        'h-full px-6 md:px-6 lg:px-8 xl:px-16 pb-8 md:pt-4 md:pb-6 lg:py-12'
      )}
    >
      <h2 className="heading-medium lg:heading-large xl:heading-xlarge 2xl:heading-xxlarge mb-6">
        {title}
      </h2>
      <p className="tracked-medium hidden md:block mb-4 2xl:tracked-large">{description}</p>
      <ul className="list-disc pl-4 space-y-2 mb-8">
        {features.map((ele: string) => (
          <li className="paragraph-medium 2xl:paragraph-large" key={ele}>
            {ele}
          </li>
        ))}
      </ul>
      <SlatButton {...link} />
    </div>
  </div>
);

const ProductComparison: FC<any> = ({ cards, flyers }) => {
  return (
    <div>
      <h2 className="text-center px-6 pt-10 pb-4 heading-serif-small md:heading-serif-medium lg:heading-serif-large xl:heading-serif-xlarge 2xl:heading-serif-xxlarge">
        What’s your invitation style?
      </h2>
      <h3 className="text-center px-4 pb-4 md:pb-0 paragraph-medium max-w-screen-lg mx-auto 2xl:paragraph-large">
        Whichever you pick, you’ll have access to instant RSVP tracking, guest messaging, and more.
      </h3>
      <div className="flex flex-row flex-nowrap items-stretch overflow-x-scroll md:overflow-x-auto text-lapel pt-4 pb-8 px-4 md:px-6 md:py-6 space-x-4 lg:space-x-6">
        <ProductTile {...cards} />
        <ProductTile {...flyers} />
      </div>
    </div>
  );
};

export default ProductComparison;
